// Default map settings for Google Maps
export const DEFAULT_CENTER = {
  lng: -73.98953918788182,
  lat: 40.75541295986449,
};

export const DEFAULT_ZOOM = 12;

export const GOOGLE_MAP_ID = process.env.NEXT_PUBLIC_GOOGLE_MAP_ID;
